module.exports = __webpack_public_path__ + "static/ciclista-f3f8f4d0314dc3bcd98229903a3b022a.svg";